import React from 'react';
import PropTypes from 'prop-types';

export default class BusinessGames extends React.PureComponent {
  static propTypes = {
    data: PropTypes.array.isRequired,
  }

  state = {
    data: this.props.data,
    businessgames:[],
  };

  componentDidMount() {
    // Only process data if it's available
    if (this.state.data && this.state.data.length > 0) {
      this.processData();
    }
  }

  componentDidUpdate(prevProps) {
    // Check if data prop has been updated and is now available
    if (prevProps.data !== this.props.data && this.props.data.length > 0) {
      this.setState({ data: this.props.data }, () => {
        this.processData();
      });
    }
  }

  processData() {
    const data = this.state.data;

    const businessgames = data.filter(function(caseProject) {
      return caseProject.sys.contentType.sys.id === 'tyelmnPeli';
    });

    businessgames.sort(function(a, b) {
      return (a.createdAt < b.createdAt) ? -1 : ((a.createdAt > b.createdAt) ? 1 : 0);
    });

    this.setState({businessgames: businessgames});
  }

  render() {
    // Add a guard for empty data
    if (!this.state.businessgames || this.state.businessgames.length === 0) {
      return <div>Loading business games...</div>;
    }

    const bgStyle = { __html: 'body:after { display:none; } body { background:linear-gradient(45deg, #c1347a,#6934c1); } ' };

    return (
      <div>
        <style
          dangerouslySetInnerHTML={bgStyle}
        />
        {this.state.businessgames.map(({ fields }, i) => (
          <a key={i} href={JSON.parse(JSON.stringify(fields.osoite))} className="business-game">
            <img 
              className="business-game-thumb" 
              src={JSON.parse(JSON.stringify(fields.kuva.fields.file.url + '?w=600&h=400&fm=jpg&q=60'))}
            />
            <div className="business-game-title">{JSON.parse(JSON.stringify(fields.nimi))}</div>
          </a>
        ))}
      </div>
    );
  }
}
